import { render, staticRenderFns } from "./CriteriaGuideModal.vue?vue&type=template&id=dada6e54&"
import script from "./CriteriaGuideModal.vue?vue&type=script&lang=ts&"
export * from "./CriteriaGuideModal.vue?vue&type=script&lang=ts&"
import style0 from "./CriteriaGuideModal.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports